import useAuth from './useAuth';

export default function useOrgId(): string | null {
  const { userInfo } = useAuth();
  return userInfo?.orgId ?? null;
}
